import { Box, useTheme } from "@mui/material";
import { useCallback, useContext, useEffect, useState } from "react";

import UpgradeApplicationWindow from "@/components/electron/UpgradeApplicationWindow.tsx";
import SimpleModal from "@/components/SimpleModal.tsx";
import { UserContext } from "@/models/StateProviders/userProvider.tsx";
import { ipcRendererCallback, ipcRendererSend, removeIpcListener } from "@/utils";

type UpdatesAvailable = { available: boolean; version: string };
export default function ElectronAppVersion() {
  const theme = useTheme();
  const [showUpgradeWindow, setShowUpgradeWindow] = useState<boolean>(false);
  const [noCloseValue, setNoCloseValue] = useState<boolean>(false);
  const [updatesAvailable, setUpdatesAvailable] = useState<UpdatesAvailable | null>(null);
  const updateAvailableCallback = useCallback((_: any, value: UpdatesAvailable) => setUpdatesAvailable(value), []);
  const { appVersion } = useContext(UserContext);

  useEffect(() => {
    ipcRendererCallback("update-available", updateAvailableCallback);
    ipcRendererSend("check-for-updates");
    return () => {
      removeIpcListener("update-available", updateAvailableCallback);
    };
  }, [updateAvailableCallback]);

  if (appVersion) {
    return (
      <>
        <SimpleModal
          disableClose={noCloseValue}
          closeModal={() => setShowUpgradeWindow(() => false)}
          open={showUpgradeWindow}
          sx={{ maxWidth: "330px" }}
          title="Upgrade Application"
        >
          <UpgradeApplicationWindow setNoClose={(value: boolean) => setNoCloseValue(() => value)} />
        </SimpleModal>
        <Box sx={{ mx: 2, display: "flex", alignItems: "center", gap: 1 }}>
          <Box sx={{ width: "50%" }}>
            <span style={{ color: theme.palette.secondary.contrastText }}>Current Version:</span>{" "}
            <strong>{appVersion}</strong>
          </Box>
          {updatesAvailable?.available == true && (
            <button
              onClick={() => setShowUpgradeWindow(() => true)}
              className="basic-button active"
              style={{ width: "50%", padding: "0.5rem", textAlign: "center", justifyContent: "center" }}
            >
              <span>Latest Version:</span> <strong>{updatesAvailable.version}</strong>
            </button>
          )}
        </Box>
      </>
    );
  }
}
